<template>
  <main class="w-full flex-grow p-6">
    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">Avatar (150 px X 150 px)</div>
            <div @click="showModalAvatar" class="mr-5 cursor-pointer">
              <fas icon="pencil-alt" class="text-app-default text-2xl" />
            </div>
          </div>
          <div class="flex">
            <img
              v-if="'profile.user_avatar' !== ''"
              :src="profile.user_avatar"
              @click="showModal(profile.user_avatar)"
              alt="23paskal"
              class="rounded-full w-52 h-52 cursor-pointer"
            />
            <img
              v-else
              src="https://api.23paskal.id/images/default.jpg"
              alt="23paskal"
              class="rounded-full w-52 h-52"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">Email</div>
            <div @click="showModalEmail" class="mr-5 cursor-pointer">
              <fas icon="pencil-alt" class="text-app-default text-2xl" />
            </div>
          </div>
          <div class="flex">
            {{ profile.email }}
          </div>
        </div>
      </div>
    </div>

    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">Password</div>
            <div @click="showModalPassword" class="mr-5 cursor-pointer">
              <fas icon="pencil-alt" class="text-app-default text-2xl" />
            </div>
          </div>
          <div class="flex">
            ******
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Avatar -->
    <div
      v-if="modalAvatar"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 350px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <button
            @click.self="showModalAvatar"
            class="fill-current h-6 w-6 absolute right-0 top-0 m-6 font-3xl font-bold"
          >
            &times;
          </button>
          <div class="px-6 py-3 text-xl border-b font-bold">
            Avatar (150 px X 150 px)
          </div>
          <div class="p-6 flex-grow">
            <div class="">
              <div
                class="border-dotted border-2 border-black p-2 rounded-lg"
                @drop="previewUserAvatar"
              >
                <input
                  type="file"
                  accept="image/*"
                  @change="previewUserAvatar"
                  id="user_avatar"
                  class="opacity-0 hidden"
                />
                <div class="flex flex-row">
                  <div
                    v-if="update.previewUserAvatar"
                    class="mr-1 relative rounded-lg w-full"
                  >
                    <button
                      class="absolute right-2 top-2"
                      type="button"
                      @click="removeUserAvatarFile"
                    >
                      <fas icon="trash-alt" class="text-red-600 text-3xl" />
                    </button>
                    <img
                      :src="update.previewUserAvatar"
                      class="w-full h-52 rounded-lg"
                    />
                  </div>
                  <div
                    v-if="update.previewUserAvatar === null"
                    v-cloak
                    @click="chooseUserAvatarFile()"
                    class="w-full h-52 mr-1 rounded-lg cursor-pointer bg-gray-200 flex items-center justify-center"
                  >
                    <fas icon="image" class="text-gray-600 text-3xl" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="showModalAvatar"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                :disabled="!update.previewUserAvatar"
                @click="updateUserAvatar"
                type="button"
                class="text-gray-200 rounded px-4 py-2 w-32"
                :class="[
                  !update.previewUserAvatar ? 'bg-gray-500' : 'bg-blue-600',
                ]"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="showModalAvatar"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- Modal Email -->
    <div
      v-if="modalEmail"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 800px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <button
            @click.self="showModalEmail"
            class="fill-current h-6 w-6 absolute right-0 top-0 m-6 font-3xl font-bold"
          >
            &times;
          </button>
          <div class="px-6 py-3 text-xl border-b font-bold">Email</div>
          <div class="p-6 flex-grow">
            <div class="flex flex-wrap">
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80">Email</label>
                <input
                  v-model="update.email"
                  type="text"
                  @keyup="emailChange"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.email
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Email"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.emailMessage }}
                </div>
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="showModalEmail"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                @click="updateEmail"
                type="button"
                class="bg-blue-600 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="showModalEmail"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- Modal Password -->
    <div
      v-if="modalPassword"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 800px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <button
            @click.self="showModalPassword"
            class="fill-current h-6 w-6 absolute right-0 top-0 m-6 font-3xl font-bold"
          >
            &times;
          </button>
          <div class="px-6 py-3 text-xl border-b font-bold">Password</div>
          <div class="p-6 flex-grow">
            <div class="flex flex-wrap">
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Old Password</label
                >
                <input
                  v-model="update.oldPassword"
                  @keyup="oldPasswordChange"
                  type="password"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.oldPassword
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Old Password"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.oldPasswordMessage }}
                </div>
              </div>
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >New Password</label
                >
                <input
                  v-model="update.newPassword"
                  @keyup="newPasswordChange"
                  type="password"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.newPassword
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="New Password"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.newPasswordMessage }}
                </div>
              </div>
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Repeat New Password</label
                >
                <input
                  v-model="update.repetNewPassword"
                  @keyup="repetNewPasswordChange"
                  type="password"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.repetNewPassword
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Repeat New Password"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.repetNewPasswordMessage }}
                </div>
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="showModalPassword"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                @click="updatePassword"
                type="button"
                class="bg-blue-600 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="showModalPassword"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>
    <Modal v-show="isModalVisible" @close="closeModal" :imageso="imageso" />
    <SuccessNotif />
    <Warning />
  </main>
</template>

<script>
import API from "../../api";
import Modal from "../../components/Modal.vue";
import SuccessNotif from "../../components/SuccessNotif.vue";
import Warning from "../../components/Warning.vue";
export default {
  name: "Information",
  components: {
    Modal,
    SuccessNotif,
    Warning,
  },
  data() {
    return {
      api: process.env.VUE_APP_API,
      imageso: "",
      isModalVisible: false,
      modalAvatar: false,
      modalEmail: false,
      modalPassword: false,
      profile: {},
      errors: {
        email: false,
        emailMessage: "",
        oldPassword: false,
        oldPasswordMessage: "",
        newPassword: false,
        newPasswordMessage: "",
        repetNewPassword: false,
        repetNewPasswordMessage: "",
      },
      update: {
        email: "",
        oldPassword: "",
        newPassword: "",
        repetNewPassword: "",
        previewUserAvatar: null,
        fileUserAvatar: null,
      },
      description: "",
      saveButton: "Save",
    };
  },
  methods: {
    showModal: function(data) {
      this.imageso = data;
      this.isModalVisible = true;
    },
    closeModal: function() {
      this.isModalVisible = false;
    },
    emailChange: function(e) {
      this.update.email = e.target.value;
      this.errors.email = false;
      this.errors.emailMessage = "";
    },
    oldPasswordChange: function(e) {
      this.update.oldPassword = e.target.value;
      this.errors.oldPassword = false;
      this.errors.oldPasswordMessage = "";
    },
    newPasswordChange: function(e) {
      this.update.newPassword = e.target.value;
      this.errors.newPassword = false;
      this.errors.newPasswordMessage = "";
    },
    repetNewPasswordChange: function(e) {
      this.update.repetNewPassword = e.target.value;
      this.errors.repetNewPassword = false;
      this.errors.repetNewPasswordMessage = "";
    },
    previewUserAvatar: function(event) {
      let input = event.target;
      if (input.files) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.update.previewUserAvatar = e.target.result;
        };
        this.update.fileUserAvatar = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
    },
    removeUserAvatarFile: function() {
      this.update.previewUserAvatar = null;
      this.update.fileUserAvatar = null;
    },
    chooseUserAvatarFile: function() {
      document.getElementById("user_avatar").click();
    },
    showModalAvatar: function() {
      this.description = "";
      this.modalAvatar = !this.modalAvatar;
    },
    showModalEmail: function() {
      this.update.email = this.profile.email;
      this.modalEmail = !this.modalEmail;
    },
    showModalPassword: function() {
      this.description = "";
      this.modalPassword = !this.modalPassword;
    },
    updateUserAvatar: async function() {
      this.saveButton = "Loading...";
      let formdata = new FormData();
      formdata.append("user_avatar", this.update.fileUserAvatar);
      formdata.append("id", this.profile.id);
      try {
        let res = await fetch(`${API}v1/admin/profile/update-avatar`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: formdata,
        });
        const response = await res.json();
        if (response.status !== 200) {
          this.modalAvatar = false;
          this.saveButton = "Save";
          this._error(response.message);
          return;
        }
        this.modalAvatar = false;
        this.saveButton = "Save";
        this.findProfile();
        this._success("Avatar updated.");
      } catch (err) {
        this.modalAvatar = false;
        this.saveButton = "Save";
        this._error("internal server error");
      }
    },
    updateEmail: async function() {
      this.saveButton = "Loading...";
      try {
        let res = await fetch(`${API}v1/admin/profile/update-email`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify({
            id: this.profile.id,
            email: this.update.email,
          }),
        });
        const response = await res.json();
        if (response.status !== 200) {
          if (response.message === "ERR_FORM") {
            response.data.map((item) => {
              if (item.key === "email") {
                this.errors.email = true;
                this.errors.emailMessage = item.message;
              }
            });
          }
          this.modalPassword = false;
          this.saveButton = "Save";
          this._error(response.message);
          return;
        }
        this.modalEmail = false;
        this.findProfile();
        this.saveButton = "Save";
        this._success("Email updated.");
      } catch (err) {
        this.modalEmail = false;
        this.saveButton = "Save";
        this._error("internal server error");
      }
    },
    updatePassword: async function() {
      this.saveButton = "Loading...";
      try {
        let res = await fetch(`${API}v1/admin/profile/update-password`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify({
            id: this.profile.id,
            old_password: this.update.oldPassword,
            new_password: this.update.newPassword,
            repeat_new_password: this.update.repetNewPassword,
          }),
        });
        const response = await res.json();
        
        if (response.status !== 200) {
          if (response.message === "ERR_FORM") {
            response.data.map((item) => {
              if (item.key === "old_password") {
                this.errors.oldPassword = true;
                this.errors.oldPasswordMessage = item.message;
              }
              if (item.key === "new_password") {
                this.errors.newPassword = true;
                this.errors.newPasswordMessage = item.message;
              }
              if (item.key === "repeat_new_password") {
                this.errors.repetNewPassword = true;
                this.errors.repetNewPasswordMessage = item.message;
              }
            });
            this.saveButton = "Save";
            return;
          }
          
          this.saveButton = "Save";
          this._error(response.message);
          return;
        } else {
          this.modalPassword = false;
        }
        this.findProfile();
        this.saveButton = "Save";
        this._success("Password updated.");
      } catch (err) {
        this.modalPassword = false;
        this.saveButton = "Save";
        this._error("internal server error");
      }
    },
    findProfile: async function() {
      try {
        let res = await fetch(`${API}v1/admin/profile`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.profile = respon.data;
        this.$store.dispatch("profile", respon.data);
      } catch (err) {
        this._error("internal server error");
      }
    },
    _error: function(message) {
      this.$store.dispatch("warning", {
        isError: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("warning", {
          isError: false,
          message: "",
        });
      }, 5000);
    },
    _success: function(message) {
      this.$store.dispatch("success", {
        isSuccess: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("success", {
          isSuccess: false,
          message: "",
        });
      }, 5000);
    },
  },
  created: function() {
    this.findProfile();
  },
};
</script>
